import styles from "./LoadingState.module.css";

/**
 * Shared loading state (PRD §42).
 * Copy stays in plain English, never "fetching resource".
 */
const LoadingState = ({
  title = "Getting the game ready…",
  message,
  compact = false,
  className = "",
}) => (
  <div
    className={`${styles.LoadingState} ${compact ? styles.compact : ""} ${className}`.trim()}
    role="status"
    aria-live="polite"
  >
    <span className={styles.ball} aria-hidden="true">
      <i className="fa-solid fa-football" />
    </span>
    <p className={styles.title}>{title}</p>
    {message && <p className={styles.message}>{message}</p>}
  </div>
);

export default LoadingState;
